(function () {
    'use strict';

    angular
        .module('app.layout')
        .controller('SidebarController', SidebarController);

    SidebarController.$inject = ['$scope', '$state', 'config', 'routerHelper', 'userService', 'dataservice', 'common', 'navRoutes'];
    /* @ngInject */
    function SidebarController($scope, $state, config, routerHelper, userService, dataservice, common, navRoutes) {
        var vm = this;
        vm.isCurrent = navRoutes.isCurrent;
        vm.showBadge = showBadge;

        vm.alertsCount = 0;
        vm.dashboardCount = 0;
        vm.tasksCount = 0;
        vm.dailysetupCount = 0;
        
        activate();
        
        function activate() {
            _setNavRoutes();
            common.notifier.subscribe(config.events.refreshCounts, $scope, _refreshCounts);
            common.notifier.subscribe(config.events.mainDateChange, $scope, dateChanged);
            common.notifier.subscribe(config.events.authenticationChange, $scope, _setNavRoutes);
        }

        function _setNavRoutes() {
            vm.navRoutes = navRoutes.getNavRoutes();
        }

        function dateChanged(eventName, newDate) {
            _refreshCounts();
        }

        function _refreshCounts(eventName, data) {
            if (data) {
                if (data.alertsCount) {
                    vm.alertsCount = data.alertsCount;
                }
                if (data.tasksCount) {
                    vm.tasksCount = data.tasksCount;
                }
            }
            else {
                var m = moment(common.getMainState("mainDate"));
                
                return dataservice.getCounts(m).then(function (response) {
                    var countModel = response.data;
                    vm.alertsCount = countModel.AlertCount.ActiveCount;
                   // if (vm.alertsCount > 0) {
                   //     var audio = new Audio('app/Pigeons-sound.mp3');
                   //     audio.play();
                   // }

                    vm.tasksCount = countModel.TaskCount.ActiveCount;
                }, function (error) { });
            }
        }

        function showBadge(routeTitle) {
            switch(routeTitle)
            {
                case "alerts.display":
                    return vm.alertsCount > 0;
                case "tasks.display":
                    return vm.tasksCount > 0;
                default:
                    return vm[routeTitle + "Count"] > 0;
            }
        }

       
    }
})();
